const config = {
    API_BASE_URL:"https://api.fjlc.us/",
    // API_BASE_URL:"http://localhost:9006/"
    // API_BASE_URL:"http://localhost:9025/"
    // API_BASE_URL:"http://localhost:9090/",
    AWS_URL:'https://hammerbucket.s3.us-west-1.amazonaws.com/asb_attachments/',
    AWS_IMAGE_URL:'https://hammerbucket.s3.us-west-1.amazonaws.com/hammer_photos/'
}
export {config}
